import React from "react";
import styled from "styled-components";
import { Button } from "components/generic/kit";
import closeIcon from "../assets/close.svg";
import Filter from "./Filter";

export default ({ filters, toggleModal, onFilterChange, selected }) => (
  <React.Fragment>
    <div className="tr pa3">
      <img onClick={toggleModal} src={closeIcon} alt="Close modal" />
    </div>
    <div className="tl ph3 f3">
      <Title>Filters</Title>
    </div>
    <div className="pa3">
      {filters.map((filter, i) => (
        <div className="mb2">
          <Filter
            {...filter}
            selected={selected[filter.field]}
            onFilterChange={onFilterChange}
            key={i}
          />
        </div>
      ))}
    </div>
    <div className="mh3">
      <Button color="transparent" onClick={() => toggleModal()}>
        Apply filters
      </Button>
    </div>
  </React.Fragment>
);

const Title = styled.span`
  font-family: CircularStd-Book;
  color: #a1a19f;
  font-weight: normal;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/MobileFilters.js